export default async function loadIVSLibrary() {
    await load("https://player.live-video.net/1.1.2/amazon-ivs-videojs-tech.min.js")
}

function load(url) {
	return new Promise(function(resolve, reject) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.src = url;
		script.onload = resolve;
		script.onerror = reject;
		document.body.appendChild(script);
	})
}